import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import FinancementPage from "@/pages/FinancementPage";
import ContactPage from "@/pages/ContactPage";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Cookies from "@/pages/Cookies";
import PlaceholderPage from "@/pages/PlaceholderPage";

const NOT_FOUND = (
    <PlaceholderPage
        kicker="404"
        title="Page introuvable"
        note="Cette page n'existe pas. Revenez à l'accueil ou utilisez le menu."
    />
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/financement" element={<FinancementPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/confidentialite" element={<Confidentialite />} />
                    <Route path="/cookies" element={<Cookies />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/404" element={NOT_FOUND} />
                    <Route path="*" element={NOT_FOUND} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
